import { stringify } from 'qs';
import { privateClient, eldoradoClient } from './client';
import localStorage from 'local-storage-fallback';
import partner from '../constants/partner';

const fetchBrands = () => eldoradoClient.get('/v1/brand');

const requestBraspagToken = (sessionId, brand) => privateClient(sessionId).get(`/braspag/brand/${brand}/access-token`, { headers: { 'x-api-key': process.env.REACT_APP_X_API_KEY_BFF } });

const requestTokenization = (pan, month, year) =>
  eldoradoClient.post('/v1/cc', stringify({ pan, month, year, partner }));

const requestCardRemove = (type, token) =>
  privateClient.delete(
    `/customers/${localStorage.getItem('msisdn')}/payment-methods/${type}-${token}`,
  );

export { fetchBrands, requestTokenization, requestCardRemove, requestBraspagToken };
